export default __webpack_public_path__ + "static/media/kitchen3-after3-1024w.4226e651.avif";